import { render } from "./quiz4.vue?vue&type=template&id=cad93982&scoped=true"
import script from "./quiz4.vue?vue&type=script&lang=js"
export * from "./quiz4.vue?vue&type=script&lang=js"

import "./quiz4.vue?vue&type=style&index=0&id=cad93982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad93982"]])

export default __exports__